import { render } from "./Indicator.vue?vue&type=template&id=c41b0754&scoped=true"
import script from "./Indicator.vue?vue&type=script&lang=js"
export * from "./Indicator.vue?vue&type=script&lang=js"

import "./Indicator.vue?vue&type=style&index=0&id=c41b0754&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c41b0754"]])

export default __exports__